var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"footer-container mt-100"},[_vm._m(0),_c('top-footer',{attrs:{"topFooter":_vm.footer}}),_c('bottom-footer'),_c('fixed-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"f-r grid",attrs:{"src":"/assets/landing/images/footer/repeat-grid.svg","alt":""}})])
}]

export { render, staticRenderFns }